module.exports = __webpack_public_path__ + "img/1.0b67a60e.png";